import React from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { selectPotsStatuses, selectShouldForceShowPotsOnb } from '../reducers/selectors';
import LoadingView from './LoadingView';
import Onboarding from './Onboarding';
import OnboardingFunnel from './OnboardingFunnel';
import ProductTourComponent from './ProductTourComponent';
const OnboardingFunnelController = () => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const { status } = useAppSelector(selectPotsStatuses);
    const shouldShowPotsOnb = useAppSelector(selectShouldForceShowPotsOnb);
    const hasPostOpenInstructions = useAppSelector((state) => state.pots.hasPostOpenInstructions);
    if (status === undefined) {
        return (<View style={paddingHorizontalStyle}>
        <LoadingView />
      </View>);
    }
    if (status === 'NOT_STARTED' || (shouldShowPotsOnb && !hasPostOpenInstructions)) {
        return <ProductTourComponent />;
    }
    if (status === 'CLOSED' || status === 'FROZEN' || status === 'NOT_ELIGIBLE' || status === 'CLOSING_IN_PROGRESS') {
        return <Onboarding status={status}/>;
    }
    return (<View style={paddingHorizontalStyle}>
      <OnboardingFunnel status={status}/>
    </View>);
};
export default OnboardingFunnelController;
